import AxiosInstance from "./api";

export const StockLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/stock-ledger/paginate", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/stock-ledger/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/stock-ledger/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/stock-ledger", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/stock-ledger/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/stock-ledger/" + id);
  },
};
